import React from "react"
import TicketMiniBlue from "../../../../icons/TicketBlue"
import dayjs from "dayjs"
import { useRouter } from "next/router"
import { useLang } from "hooks/useLang"
import Image from "next/image"
import CustomImage from "components/atoms/Image/CustomImage"
import { getEventPosterUrl } from "components/atoms/Image/EventPoster"

interface IProps {
    title: string
    numberOfTickets: number
    status: string
    poster: string
    id: string
    cart: any
    Price: number
    PDF?: string
    orderRef?: string
    cartId: string
    location: string
    startTime: string
    endTime: string
    uniqueId: number
}

const OrderCard = (props: IProps) => {
    const {
        title,
        numberOfTickets,
        status,
        poster,
        id,
        cart,
        Price,
        PDF,
        orderRef,
        cartId,
        location,
        startTime,
        endTime,
        uniqueId,
    } = props
    const { t } = useLang()
    const router = useRouter()

    const statusStyle = () => {
        switch (status) {
            case "Confirmed":
                return "bg-green-50 text-green-600"
            case "Pending":
                return "bg-yellow-50 text-yellow-600"
            case "CANCELLED":
                return "bg-red-50 text-red-600"
            default:
                return ""
        }
    }

    const statusDot = () => {
        switch (status) {
            case "Confirmed":
                return "bg-green-600"
            case "Pending":
                return "bg-yellow-600"
            case "CANCELLED":
                return "bg-red-600"
            default:
                return ""
        }
    }

    return (
        <div
            key={uniqueId}
            onClick={() =>
                router.push({
                    pathname: `/order-status/${cartId}`,
                })
            }
            className={`flex flex-col overflow-hidden rounded-md bg-white text-sm shadow-3xl dark:bg-white md:flex-row md:text-base`}
        >
            <div className="relative h-[200px] md:h-full md:flex-1">
                <CustomImage
                    // src={`https://cdn.pass-tickets.com/images/${poster}`}
                    src={poster}
                    alt={`poster-${poster}`}
                    fill
                    style={{ objectFit: "cover" }}
                />
            </div>

            {/* info cantainer */}
            <div className="flex flex-[2] justify-between p-5">
                {/* Left side */}
                <div className="flex flex-col gap-4">
                    <h1 className="font-bold capitalize text-black">{title}</h1>
                    <div>
                        <div className="text-blackcapitalize font-semibold">
                            {t("day")}
                        </div>
                        <div className="text-sm text-black">
                            {dayjs(endTime).format("MMM D, YYYY")}
                            <span> - </span>
                            {dayjs(startTime).format("MMM D, YYYY")}
                        </div>
                    </div>
                    <div>
                        <div className="font-semibold capitalize text-black">
                            {t("time")}
                        </div>
                        <div className="text-sm text-black">
                            {`${dayjs(endTime).format("A H:mm")} - ${dayjs(
                                startTime
                            ).format("H:mm A")}`}
                        </div>
                    </div>
                    <div>
                        <div className="text-blackcapitalize font-semibold">
                            {t("location")}
                        </div>
                        <div className="text-sm text-black">{t(location)}</div>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="font-semibold capitalize text-black">
                            {t("status")}
                        </div>
                        <div
                            className={`flex items-center gap-2 rounded-md px-2 text-sm ${statusStyle()}`}
                        >
                            {t(status)}
                            <span
                                className={`block h-[7px] w-[7px] rounded-full ${statusDot()}`}
                            />
                        </div>
                    </div>
                </div>

                {/* Right side */}
                <div className="flex flex-col items-end justify-between">
                    <div className="flex items-center gap-2">
                        <TicketMiniBlue />
                        <span className="text-action-theme-400">
                            {numberOfTickets}
                        </span>
                    </div>

                    <div className="w-fit cursor-pointer text-xs font-semibold text-action-theme-200 hover:underline">
                        {t("viewInvoice")}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrderCard
